/* eslint-disable no-console */

import { register } from 'register-service-worker'
import store from "./store";

if (process.env.NODE_ENV === 'production') {
  // register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
  //   // event listeners go here...
  // });
  // let isRefreshed = false;
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () { // registration
      console.log('Service worker has been registered.')
      // console.log(registration)
      // self.addEventListener('install', function(event) {
      //   event.waitUntil(
      //     caches.open('my-cache').then(function(cache) {
      //       return cache.addAll([
      //         '/',
      //         '/index.html',
      //         '/app.js',
      //         '/styles.css'
      //       ]);
      //     })
      //   );
      // });
  
      // self.addEventListener('activate', function(event) {
      //   event.waitUntil(
      //     self.skipWaiting()
      //   );
      // });
  
      // self.addEventListener('message', function(event) {
      //   if (event.data.action === 'skipWaiting') {
      //     self.skipWaiting();
      //   }
      // });
  
      // self.addEventListener('fetch', function(event) {
      //   event.respondWith(
      //     caches.match(event.request).then(function(response) {
      //       return response || fetch(event.request);
      //     })
      //   );
      // });
    },
    cached (registration) {
      console.log('Content has been cached for offline use.')
      console.log(registration)
    },
    updatefound () {
      console.log('New content is downloading.')
      // console.log(registration)
      // store.dispatch("appUpdate", true);
    },
    updated () {
      console.log('New content is available; please refresh.')
      caches.keys().then(function(names) {
        for (let name of names) caches.delete(name);
      });
      // store.dispatch("appUpdate", false);
    //     if (confirm('A new version of the app is available. Do you want to update now?')) {          
    //     // registration.waiting.postMessage({ action: 'skipWaiting' })
        
    //     // Clear cache on update
    //     caches.keys().then(function(cacheNames) {
    //       cacheNames.forEach(function(cacheName) {
    //         caches.delete(cacheName);
    //       });
    //     });
    //     if (!isRefreshed) {
    //     // Reload the page only once        
    //     isRefreshed = true;
    //     window.location.reload(true);
    //     }
    //   } else {
    //     registration.waiting.postMessage({ action: 'skipWaiting' })
    //     console.log('Update declined.')
    //   }     
    //   console.log(isRefreshed)
     },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
      store.dispatch("appOffline", true);
      
    },
    error (error) {
      console.error('Error during service worker registration:', error)
      const retryCount = parseInt(localStorage.getItem('retryCount') || '0', 10);
      if (retryCount < 3) {  // Limit to 3 retries
        localStorage.setItem('retryCount', (retryCount + 1).toString());
        window.location.reload(true);
      } else {
        localStorage.removeItem('retryCount');  // Reset retry count
        window.location.href = '/fallback.html';  // Redirect to fallback page
      }
    }
  })
}
